import { IRouteProps } from '@partnerconnect-monorepo/types/Routes';
import { NotFound } from './pages/NotFound/NotFound';
import { NoAccess } from './pages/NoAccess/NoAccess';
import { Support } from './pages/Support/Support.connect';
import { Preferences } from './pages/Preferences/Preferences.connect';
import { LoginCallback } from './pages/LoginCallback/LoginCallback';

// this routes will be applied when application are deployed on base route
export const independentAppSharedRoutes: Array<IRouteProps> = [
  {
    path: '/auth/callback',
    component: LoginCallback
  },
  {
    path: '*',
    component: NotFound
  },
  {
    path: '/support',
    component: Support
  },
  {
    path: '/preferences',
    component: Preferences
  },
  {
    path: '/no-access',
    component: NoAccess
  }
];

export const sharedRoutes = [
  {
    path: '*',
    component: NotFound
  }
];
